import { useTranslation } from 'react-i18next'
import Main from '@/views/layouts/main'
import MessageErrorComponent from '@/views/components/message-error/index.component'

const ErrorPage = () => {
  const { t } = useTranslation()
  return (
    <Main center>
      {
        <MessageErrorComponent
          message={t('error.theRequestPageWasNotFoundOnThisServer')}
        />
      }
    </Main>
  )
}

export default ErrorPage
